<template>
  <div class="login_body">
    <div class="login text-center">
      <img
        src="@/assets/logo.png"
        alt="logo"
        style="height: 164px; width: auto"
      />
      <br />
      <b-form @submit.prevent="loginForm" method="post">
        <b-form-group>
          <b-form-input
            v-model="user.email"
            placeholder="Email Address"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-input
            type="password"
            v-model="user.password"
            placeholder="Password"
            required
          ></b-form-input>
        </b-form-group>

        <b-button type="submit" squared block variant="info">LogIn</b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        email: null,
        password: null,
      },
    };
  },

  methods: {
    loginForm() {
      if (this.user.email && this.user.password) {
        this.$http.post(`auth/adminLogin`, this.user).then(
          (response) => {
            localStorage.adminKB = JSON.stringify(response.data.data);

            location.reload();
          },
          (err) => {
            // console.log(err.response.data.message)
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: err.response.data.message,
              life: 3000,
            });
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.login_body {
  height: 100vh;
  background-image: url("../assets/login-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  font-family: "Patrick Hand", cursive;
}
.login {
  width: 600px;
  height: 370px;
  padding: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.4);
  border-radius: 10px;
}
.login img {
  width: 40%;
}
</style>
